import React from 'react';

function joinClassNames(...classNames) {
  return classNames.filter(Boolean).join(' ');
}

export default function PanelEmptyState({
  icon,
  title,
  description,
  actions,
  className = '',
}) {
  return (
    <div className={joinClassNames('panel-empty-state', 'panel-empty-state--centered', className)}>
      {icon && <div className="panel-empty-state-icon">{icon}</div>}
      {title && <strong>{title}</strong>}
      {description && <p>{description}</p>}
      {actions && <div className="panel-empty-state-actions">{actions}</div>}
    </div>
  );
}